<template lang="html">
  <div id="configuracion" class="container-fluid">
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="panel-body">
          <div class="col-md-12 col-sm-12 col-xs-12" style="margin-top:80px;">
            <h5 class="">Estado de RTUs</h5>
          </div>
          <table class="table table-hover">
            <thead>
              <tr class="text-center">
                <th>Ducto/Sitios</th>
                <th>Hora evento</th>
                <th>Presión</th>
                <th>Flujo</th>
                <th>Batería</th>
                <th>Sitio</th>
                <th>Gabinete</th>
                <!-- <th>Fuga</th> -->
                <th>GPS</th>
              </tr>
            </thead>
            <tbody v-for="(section, key_section, index) in monitoringData.rtu" :key="key_section" v-if="sectionHasData(section)"> <!-- //  v-show="r.site_leak === 1" // -->
              <tr @click="showDucto(`ductos${section.id_section}`)">
                <td class="nombre-ducto">{{ section.section_name }}</td>
                <td class="nombre-ducto">
                  <i v-if="sectionHasFailure(section, 'online', 0)" class="material-icons md-24 fail-icon" aria-hidden="true">link_off</i>
                </td>
                <td colspan="1" class="nombre-ducto">
                  <i v-if="sectionHasFailure(section, 'pressure', 0)" class="material-icons md-24 fail-icon">trending_down</i>
                </td>
                <td colspan="1" class="nombre-ducto">
                </td>
                <td colspan="1" class="nombre-ducto">
                  <i v-if="sectionHasFailure(section, 'battery', 10)" class="material-icons md-24 fail-icon">battery_alert</i>
                </td>
                <td colspan="1" class="nombre-ducto">
                  <i v-if="sectionHasFailure(section, 'site_door', 1)" class="material-icons md-24 fail-icon">lock_open</i>
                </td>
                <td colspan="1" class="nombre-ducto">
                  <i v-if="sectionHasFailure(section, 'cabinet_door', 1)" class="material-icons md-24 fail-icon">lock_open</i>
                </td>
                <!-- <td class="nombre-ducto">
                </td> -->
                <td colspan="1" class="nombre-ducto">
                  <i v-if="sectionHasFailure(section, 'gps', 0)" class="material-icons md-24 fail-icon">location_off</i>
                  <i class="fa fa-angle-down pull-right fa-2x" aria-hidden="true"></i>
                </td>
              </tr>
              <tr v-for="(site, key_site, index) in section.sites" v-if="site.timestamp" :key="key_site" 
                :class="[`ductos${section.id_section}`, !site.redraw && 'no-show', !site.enabled && 'site-disabled']" style="vertical-align: middle;" 
                @click="promptSiteStatus(Object.assign({}, site, { id_section: section.id_section, key_section: key_section, key_site: key_site }))"> <!--  -->
                <td>{{site.site_name}} <i v-if="!site.enabled" class="material-icons md-24 fail-icon">cloud_off</i></td>
                <td :class="[siteHasFailure(site, 'online', 0) ? 'failure' : '']">{{site.timestamp}}</td>
                <td colspan="1" :class="[siteHasFailure(site, 'pressure', 0) ? 'failure' : '']">{{site.pressure}}</td>
                <td colspan="1" >{{site.flow}}</td>
                <td colspan="1" :class="[siteHasFailure(site, 'battery', 10) ? 'failure' : '']">{{site.battery}}</td>
                <td colspan="1" :class="[siteHasFailure(site, 'site_door', 1) ? 'failure' : '']">{{site.site_door}}</td>
                <td colspan="1" :class="[siteHasFailure(site, 'cabinet_door', 1) ? 'failure' : '']">{{site.cabinet_door}}</td>
                <!-- <td>{{site.leak}}</td> -->
                <td colspan="1" :class="[siteHasFailure(site, 'gps', 0) ? 'failure' : '']">{{site.gps}}</td>
              </tr>
              <tr style="height: 10px"></tr>
            </tbody>
          </table>
        </div>

        <div class="panel-body">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <h5 class="">Fugas fuera de rango <span style="fontSize: 0.5em;">(Últimas 6 horas)</span></h5>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12 leak-table-toggle" @click="showLeaks()">
            <p style="margin: auto; vertical-align: middle; width: auto; display: inline;">Datos</p>
            <i class="fa fa-angle-down pull-right fa-2x" aria-hidden="true"></i>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12 leaks-oor no-show" style="height: 350px; overflow: scroll;">
            <table class="table table-hover">
              <thead>
                <tr class="text-center">
                  <th>Km</th>
                  <th>Lat</th>
                  <th>Lon</th>
                  <th>Hora evento</th>
                  <th>Tipo</th>
                  <th>Estado</th>
                  <th>Hora captura</th>
                </tr>
              </thead>
              <tbody> <!-- //  v-show="r.site_leak === 1" // -->
                <tr v-for="(leak, key_leak, index) in monitoringData.leaks" :key="leak.id_leak" 
                  :class="[]" style="vertical-align: middle;" @click="promptPublishLeak(leak.id_leak)"> <!--  -->
                  <td>{{`${leak.km}`}}</td>
                  <td>{{leak.lat}}</td>
                  <td>{{leak.lon}}</td>
                  <td>{{leak.detection_timestamp}}</td>
                  <td>{{leak.type === 1 ? 'Apertura' : 'Cierre'}}</td>
                  <td>{{leak.status === 0 ? 'Generado' : (leak.status === 1 ? `Publicado por ${leak.username}` : 'N/A')}}</td>
                  <td>{{leak.timestamp}}</td>
                </tr>
                <tr style="height: 10px"></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="panel-body" style="margin-top: 25px">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <h5 class="" style="">Configuración</h5>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="row">
              <div class="col-md-6 col-sm-6 col-xs-6">
                <h6>Modo manual de detección de fugas</h6>
                <label style="fontSize: 1em;">Deshabilita la publicación de fugas mientras esté encendido</label>  
              </div>
              <div class="col-md-6 col-sm-6 col-xs-6" style="margin: auto; text-align: center; vertical-align: middle;">
                <label class="switch" style="margin: auto; vertical-align: middle;">
                  <input type="checkbox" id="config-leak-manual">
                  <span class="slider round"></span>
                </label>
              </div> 
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal v-if="modalType===0" :name="modalName" cclass="transparent">
      <loading-modal :info="info"></loading-modal>
    </modal>

    <modal v-if="modalType===1" name="comentario">
      <div class="modal-body row">
        <!-- content goes here -->
        <h5 class="modal-title text-uppercase" style="padding: 15px;">{{modalSite.site_name}}</h5>
      </div>
      <div class="modal-footer">
        <p class="modal-title" style="padding: 15px; text-align: center;">{{`¿Deseas ${modalSite.enabled ? 'deshabilitar el rtu? Dejará de producir información referente a su estado.' : 'habilitar el rtu?'}`}}</p>
        <div class="btn-group btn-group-justified" role="group" aria-label="group button">
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-default waves-effect waves-light" data-dismiss="modal" role="button">Cerrar</button>
          </div>
          <div class="btn-group" role="group">
            <button type="button" id="btn-post-site" @click="postSiteEnabled(modalSite)" class="btn btn-default waves-effect waves-light" data-action="save" role="button">Continuar</button>
          </div>
        </div>
      </div>
    </modal>

    <modal v-if="modalType===2" name="publish">
      <div class="modal-body row">
        <!-- content goes here -->
        <h5 class="modal-title text-uppercase" style="padding: 15px;">Publicación manual de fuga</h5>
      </div>
      <div class="modal-footer">
        <p class="modal-title" style="padding: 15px; text-align: center;">{{`¿Deseas publicar manualmente la fuga?`}}</p>
        <div class="btn-group btn-group-justified" role="group" aria-label="group button">
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-default waves-effect waves-light" data-dismiss="modal" role="button">Cerrar</button>
          </div>
          <div class="btn-group" role="group">
            <button type="button" id="btn-post-site" @click="postPublishLeak(publishLeak)" class="btn btn-default waves-effect waves-light" data-action="save" role="button">Continuar</button>
          </div>
        </div>
      </div>
    </modal>
    <button id="loading-btn" class="hidden" type="button" data-toggle="modal" data-target="#loading-modal-modal"></button>
    <button id="enable-btn" class="hidden" type="button" data-toggle="modal" data-target="#comentario-modal"></button>
    <button id="publish-btn" class="hidden" type="button" data-toggle="modal" data-target="#publish-modal"></button>
  </div>
</template>

<script>
import Vue from 'vue'
// import toastr from 'toastr'
import Modal from 'reusable/Modal'
import LoadingModal from './../Modals/LoginModal'
var $ = require('jquery')

export default {
  data() {
    return {
      section: 'Monitoreo',
      monitoringData: {...this.$store.monitoring},
      rtuData: [],
      leaksData: [],

      updateTimer: undefined,
      info: {
        modalName: this.modalName
      },
      modalName: 'loading-modal',

      modalSite: {},
      modalType: 0,
      showInitialLoading: false,

      publishLeak: -1
    }
  },
  mounted() {
    $('#loading-btn').click()
    const fetchMonitoring = () => {
      this.$store.dispatch('GET_MONITORING')
      .then(data => {})
      .catch(err => {})
      .then(() => {
        if(!this.showInitialLoading) {
          this.showInitialLoading = true
          $('#loading-btn').click()
          setTimeout(() => {
            this.modalType = 1
          }, 500)
        }
        this.updateTimer = setTimeout(fetchMonitoring, 60000)
      })
    }
    fetchMonitoring()
    this.$store.watch(
      (state) => {
        return state.monitoring
      }, 
      () => {
        this.drawMonitrongInfo()
      }, {
        immediate: true
      }
    )

    const _this = this
    const user = Vue.ls.get('user')
    $('#config-leak-manual').click(function () {
      const slider = this
      _this.modalType = 0
      setTimeout(() => { $('#loading-btn').click() }, 200)
      const checked = $(slider).prop('checked') || false
      _this.$store.dispatch('POST_MONITORING_SETTING', {
        setting: 'leak_default_status',
        value: checked ? -1 : 0,
        username: user.username
      }).then(data => {
      }).catch(err => {
        $('#config-leak-manual').prop('checked', !checked)
      }).then(() => {
        setTimeout(() => { 
          $('#loading-btn').click(); setTimeout(() => { _this.modalType = 1 }, 500) 
        }, 100) 
      })
    })
  },
  beforeDestroy() {
    clearTimeout(this.updateTimer)
  },
  methods: {
    drawMonitrongInfo() {
      const monitoring = this.$store.getters.GET_MONITORING
      if(!monitoring) {
        return
      }
      this.monitoringData = monitoring
      const settings = this.monitoringData.settings
      let value = parseInt(settings['leak_default_status'])
      $('#config-leak-manual').prop('checked', value)
    },
    sectionHasData(section) {
      let hasInfo = false
      section.sites.some(s => {
        if(s.timestamp) {
          hasInfo = true
          return true
        }
      })
      return hasInfo
    },
    showDucto(id) {
      $(`.${id}`).toggleClass('no-show')
    },
    showLeaks() {
      $(`.leaks-oor`).toggleClass('no-show')
    },
    promptSiteStatus(site) {
      this.modalType = 1
      this.modalSite = site
      Vue.nextTick(function () {
        $('#enable-btn').click()
      })
    },
    postSiteEnabled(site) {
      const user = Vue.ls.get('user')
      this.modalType = 0
      let params = Object.assign({}, 
        site, { enabled: site.enabled ? 0 : 1, username: user.username })
      this.$store.dispatch('POST_MONITORING_SITE_ENABLED', params).then(data => {
        this.monitoringData.rtu[site.key_section].sites[site.key_site].enabled = site.enabled ? 0 : 1
        this.monitoringData.rtu[site.key_section].sites[site.key_site].redraw = true
      }).catch(err => {
      }).then(() => {
        $('#loading-btn').click()
        setTimeout(() => {
          this.modalType = 1
        }, 500)
      })
    },
    promptPublishLeak(idLeak) {
      this.modalType = 2
      this.publishLeak = idLeak
      Vue.nextTick(function () {
        $('#publish-btn').click()
      })
    },
    postPublishLeak(idLeak) {
      const user = Vue.ls.get('user')
      this.modalType = 0
      let params = Object.assign({}, { id_leak: idLeak, username: user.username })
      this.$store.dispatch('POST_MONITORING_PUBLISH_LEAK', params).then(data => {
        const index = this.monitoringData.leaks.findIndex((l) => {
          return idLeak === l.id_leak
        })
        this.monitoringData.leaks[index].username = user.username
        this.monitoringData.leaks[index].status = 1
      }).catch(err => {
      }).then(() => {
        $('#loading-btn').click()
        setTimeout(() => {
          this.modalType = 2
        }, 500)
      })
    },
    sectionHasFailure(section, type, val) {
      let failure = false
      section.sites.some(v => {
        if(this.siteHasFailure(v, type, val)) {
          failure = true
          return true
        }
      })
      return failure
    },
    siteHasFailure(site, type, val) {
      if(!site.timestamp) {
        return false
      }
      if(!type) {
        return site.battery <= 10 || site.pressure === 0 || site.site_door === 1 || 
          site.cabinet_door === 1 || site.gps === 0 || site.online === 0
      } else if(type === 'battery') {
        return site[type] <= val
      } else {
        return site[type] === val
      }
    }
  },
  components: {
    Modal,
    LoadingModal
  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';
#configuracion {
  min-height: 100vh;
  padding-bottom: 30px;
  .container {
    margin-top:80px;
    height:100vh;
    .row{
      margin-bottom:20px;
    }
    p{
      font-size:9pt;
    }
    h5{
      font-size:15pt;
      color:#999;
      font-weight:800;
    }
  }

  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
    margin-top:20%;
  }

  /* Hide default HTML checkbox */
  .switch input {display:none;}

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 0px;
    bottom: 0px;
    border:1px solid lightgray;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked + .slider {
    background-color: #2196F3;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  th {
    text-align: left;
    padding-left: 25px;
    @include cMax(415px) {
      font-size: 12px;
    }
  }
  td {
    text-align: left;
    padding-left: 25px;
    background-color: $bg;
    cursor:pointer;
    tr{
      cursor:pointer;
      
    }
    i {
      color: $inactive;
      cursor: pointer;
      &:hover {
        color: white;
      }
    }
  }
  .nombre-ducto {
    cursor: pointer;
    height: 40px;
    background-color: $amarilloC;
    color: white;
    vertical-align: middle;
  }
  .fail-icon {
    color: #FF0000CC;
    vertical-align: middle;
    text-align: center;
  }
  .fail-icon:hover {
    color: red;
  }
  .material-icons.md-18 { font-size: 18px; }
  .material-icons.md-24 { font-size: 24px; }
  .material-icons.md-36 { font-size: 36px; }
  .material-icons.md-48 { font-size: 48px; }
  .info {
    // border: 1px solid red;
  }
  .panel-body {
    padding: 0;
  }
  .panel-title {
    @include cMax(415px) {
      font-size: 12px;
    }
  }
  .no-show {
    display: none;
  }
  td.failure {
    background-color: #FF0000CC !important;
  }
  tbody {
    margin-bottom: 20px !important;
  }

  tr.site-disabled > td {
    background-color: rgba(68, 68, 68, .8);
  }

  .leak-table-toggle {
    cursor: pointer;
    height: 40px;
    background-color: $amarilloC;
    color: white;
    vertical-align: middle;
    margin: auto;
    // padding: 4px;
    padding-top: 4px
  }
  
  .leak-table-toggle > i {
    color: $inactive;
    &:hover {
      color: white;
    }
  }

  tr.site-disabled > td i {
    margin-right: 10px;
    float: right;
  }

  #comentario-modal, #publish-modal {
    h3 {
      color: $titles;
      display: none;
    }

    .btn-default {
      background-color: $amarilloC;
      &:hover,
      &:active,
      &:focus {
        background-color: $amarilloO !important;
      }
    }

    label {
      color: $amarilloC;
    }
    #label-name {
      color: white;
      width: 100%;
      font-size: 16px;
      padding: 5px;
      background-color: $amarilloC;
    }

    #selectDonde {
      -webkit-appearance: none;
      -webkit-border-radius: 0px;
      width: 80%;
      height: 40px;
      padding: 5px;
    }
  }
}
#loading-modal-modal {
  background-color: $loading-modal-bg-color;
}
</style>



// WEBPACK FOOTER //
// Configuracion.vue?779bb623